import { render, staticRenderFns } from "./DsbModal.vue?vue&type=template&id=11555093"
import script from "./DsbModal.vue?vue&type=script&lang=ts"
export * from "./DsbModal.vue?vue&type=script&lang=ts"
import style0 from "./DsbModal.vue?vue&type=style&index=0&id=11555093&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports